export const StarRating = {
	parts: ["wrap", "star", "starHalf"],
	baseStyle: {
		wrap: {
			".chakra-wrap__list": {
				h: "full",
				alignItems: "center",
				mb: "0",
				svg: {
					mb: 0,
				},
			},
		},
		star: {
			color: "yellow.500",
		},
		starHalf: {
			color: "yellow.500",
		},
	},
	variants: {
		yellow: {
			star: {
				color: "yellow.500",
			},
			starHalf: {
				color: "yellow.500",
			},
		},
	},
	sizes: {
		sm: {
			star: {
				boxSize: "20px",
			},
			starHalf: {
				boxSize: "20px",
			},
		},
		md: {
			star: {
				boxSize: "30px",
			},
			starHalf: {
				boxSize: "30px",
			},
		},
		lg: {
			star: {
				boxSize: "40px",
			},
			starHalf: {
				boxSize: "40px",
			},
		},
	},
	defaultProps: {
		variant: "yellow",
		size: "md",
	},
}
